import { Validators } from "@angular/forms";

export class Prestation {
  title?: string;
  type_name?: string;

  constructor(data?: Partial<Prestation>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static attributeToJson(item: any) {
    let obj = item.attributes;
    obj["id"] = item.id;
    return obj;
  }

  static get_title() {
    return "";
  }

  static get_inputs() {
    return [];
  }

  static get_form() {
    return {};
  }

  static get_relations() {
    return [];
  }
}
